// return a fallback state depending on how data will be fetched in the searchFilterProducts helper.

export function getFallbackState({ isLoading, allProducts, filteredProducts }) {
  // Loading state
  if (isLoading) return { state: "loading" };

  // No data at all
  if (!allProducts || allProducts.length === 0) {
    return { state: "noData" };
  }

  // No results after filtering/searching
  if (filteredProducts.length === 0) {
    return { state: "noMatch" };
  }

  // success
  return { state: "ok" };
}
